export interface Event {
  ClientKey?: string;
  EndDate?: Date | string;
  Id: string;
  EventName: string;
  StartDate?: Date | string;
  selected?: boolean;
  Disclaimer?: string;
}
